import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#0f172a', color: '#fff', padding: '24px', textAlign: 'center',
    }}>
      <svg width="48" height="48" viewBox="0 0 36 36" fill="none" style={{ marginBottom: 16 }}>
        <path d="M18 3C18.5 10.5 22.5 14 33 18C22.5 22 18.5 25.5 18 33C17.5 25.5 13.5 22 3 18C13.5 14 17.5 10.5 18 3Z" fill="#f97316"/>
        <path d="M13.5 23Q18 29 22.5 23" stroke="#fff" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <circle cx="27" cy="9" r="2.5" fill="#38bdf8"/>
      </svg>
      <div style={{ fontSize: 72, fontWeight: 900, color: '#6366f1', lineHeight: 1 }}>404</div>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: '16px 0 8px' }}>Aradığınız sayfa bulunamadı</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 28 }}>
        Bu sayfa taşınmış veya hiç var olmamış olabilir.
      </p>
      <button
        onClick={() => navigate('/')}
        style={{
          background: '#6366f1', color: '#fff', border: 'none',
          padding: '12px 28px', borderRadius: 10, fontSize: 14,
          fontWeight: 700, cursor: 'pointer',
        }}
      >
        Ana Sayfaya Dön
      </button>
    </div>
  );
}
